<script setup>
import axios from 'axios'
import { ref, onMounted } from 'vue'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
};

const data = ref()

const getData = async() => {
  await axios.get("./php/getGameScore.php")
  .then((response) => {
    data.value = response.data
  })
}

onMounted(() => {
  getData()
})
</script>

<template>
  <h2>{{ data.date }}の試合</h2>
  <template v-if="data.is_game">
    <p style="font-size: 1.2em;">
      <template v-if="data.division != ''">{{ data.division }}&emsp;</template>
      {{ data.stadium }}
    </p>
    <p style="font-size: 1.5em; font-weight: bolder;"> {{ data.game_time }}</p>
  </template>
  <p style="font-size: 1.5em;"> {{ data.status }}</p>

  <table>
    <thead>
      <tr>
        <th class="team"></th>
        <template v-for="n in Object.keys(data.V.innings).length" :key="n">
          <th>{{ n }}</th>
        </template>
        <td class="space"></td>
        <th class="result">R</th>
        <td class="space"></td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="team">
          <img v-if="data.V.name != ''" decoding="async" class="petmark" :src="require('../../assets/' + data.V.name + '.png')" :alt="data.V.name">
        </td>
        <template v-for="(runs, index) in data.V.innings" :key="index">
          <td>
            <template v-if="runs.length > 1"><div>{{ runs }}</div></template>
            <template v-else>{{ runs }}</template>
          </td>
        </template>
        <td class="space"></td>
        <td class="result">
          <template v-if="data.V.runs != null && data.V.runs.length > 1"><div>{{ data.V.runs }}</div></template>
          <template v-else>{{ data.V.runs }}</template>
        </td>
        <td class="space"></td>
      </tr>
      <tr>
        <td class="team">
          <img v-if="data.H.name != ''" decoding="async" class="petmark" :src="require('../../assets/' + data.H.name + '.png')" :alt="data.H.name">
        </td>
        <template v-for="(runs, index) in data.H.innings" :key="index">
          <td>
            <template v-if="runs.length > 1"><div>{{ runs }}</div></template>
            <template v-else>{{ runs }}</template>
          </td>
        </template>
        <td class="space"></td>
        <td class="result">
          <template v-if="data.H.runs != null && data.H.runs.length > 1"><div>{{ data.H.runs }}</div></template>
          <template v-else>{{ data.H.runs }}</template>
        </td>
        <td class="space"></td>
      </tr>
    </tbody>
  </table>

  <div style="display: flex; justify-content: space-around; margin: 1.5em;">
    <a v-if="data.is_live_created" class="link-btn" style="padding: .7em 10%;" :href="'/article?tid=' + data.live_thread_id">実況スレ</a>
    <a v-if="data.is_gather_created" class="link-btn" style="padding: .7em 10%;" :href="'/article?tid=' + data.gather_thread_id">集合スレ</a>
  </div>
</template>

<style scoped>
  @media screen and (max-width: 640px) {
    td {
      font-size: 1.5em;
    }

    td > div {
      transform: scale(.75, 1);
    }
  
    th {
      font-size: 1em;
    }

    img.petmark {
      height: 2.5em;
    }
  }

  @media screen and (min-width: 640px) {
    td {
      font-size: 2em;
    }

    td > div {
      transform: scale(.9, 1);
    }
  
    th {
      font-size: 1.5em;
    }

    img.petmark {
      height: 3em;
    }
  }

  .content {
    min-height: 50vh;
  }

  table {
    table-layout: fixed;
    border-collapse: collapse;
    border-spacing: .2em;
    border-radius: .4em;
    background: rgba(0, 0, 0, .6);
    box-shadow: inset .1em .1em .5em rgba(0, 0, 0, .4), inset -.1em -.1em .5em rgba(200, 200, 200, .4);
    width: 100%;
  }

  thead {
    vertical-align: bottom;
    line-height: 1;
  }

  thead tr {
    border-bottom: 2px solid rgba(230, 180, 34, .4);
  }

  th, td, td > div {
    font-family: Oswald;
    color: #fefefe;
  }

  th, td {
    text-align: center;
    height: 2em;
    padding: .2em 0;
    border:  none;
  }

  td { 
    color: #fefefe;
  }

  th, td.team {
    background: transparent;
  }

  th.team, td.team {
    width: 4em;
  }

  td.team {
    font-size: 1.2em;
    white-space: nowrap;
    margin: 0;
    padding: 0 .5em;
    box-shadow: none;
  }

  td.space {
    width: .2em;
    height: 0;
    padding: .2em;
    background: transparent;
    box-shadow: none;
  }

  td.result, td.result > div {
    color :rgb(230, 180, 34);
  }

  td > div {
    font-size: 1em;
  }

  img.petmark {
    filter: drop-shadow(1px 2px 0px rgba(255, 255, 255, 1));
  }
</style>